import { useState, useEffect } from "react";

import { getTransactionsData } from "../../services/profileService";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../../contexts/ToastContext";
import { viewAttendeePaymentReceipt } from "../../services/eventService";

export interface Event {
  id: number;
  title: string;
  datetime: string;
  location_city: string;
}

export interface Transaction {
  id: number | null;
  amount: number;
  donation_amount: number;
  cancelled_at: string;
  createdAt: string;
  status: string;
  status_label: string;
  payment_id: string;
  refund_id: string;
  type: string;
  Event: Event;
}

const useTransactionListLogic = () => {
  const { isAuthenticated, user } = useAuth();
  const { showSuccessToast, showErrorToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState<Transaction[]>([]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const res = await getTransactionsData();
      setTransactions(res.data.data);
    } catch (err) {
      console.error("Error fetching transactions:", err);
    } finally {
      setLoading(false);
    }
  };

  const [paymentReceiptLoading, setPaymentReceiptLoading] = useState(false);

  const handleShowPaymentReceipt = async (eventId: number) => {
    try {
      if (paymentReceiptLoading) return;
      setPaymentReceiptLoading(true);
      if (!isAuthenticated) return;
      if (!eventId) return;
      const response = await viewAttendeePaymentReceipt(eventId);
      window.open(
        response.data.data.paymentIntent.latest_charge.receipt_url,
        "_blank"
      );
      showSuccessToast("Payment receipt opened in a new tab.");
    } catch (error) {
      const errorResponse = (error as any)?.response?.data || error;
      showErrorToast(errorResponse?.message || "Failed to fetch receipt.");
    } finally {
      setPaymentReceiptLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  return {
    transactions,
    loading,
    paymentReceiptLoading,
    handleShowPaymentReceipt
  };
};

export default useTransactionListLogic;
